import { computed, defineComponent, ref, } from '@vue/composition-api';
import { getSinglePlace } from '@/api/requests/places';
import { Popover } from '@/components/Popover';
import PlaceDetailsModal from '@/views/_components/PlaceDetailsModal.vue';
export default defineComponent({
    components: {
        Popover,
        PlaceDetailsModal,
    },
    props: {
        currentPlaces: {
            type: Array,
            required: true,
        },
    },
    setup(props, ctx) {
        const showModal = ref(false);
        const activePlace = ref(null);
        const isPopoverOpen = ref(false);
        const placesCount = computed(() => props.currentPlaces.length);
        const contractedPlace = computed(() => props.currentPlaces.find((item) => item.status === 'in-contract'));
        const handlePlaceClick = async (place) => {
            showModal.value = false;
            activePlace.value = null;
            isPopoverOpen.value = false;
            try {
                const placeData = await getSinglePlace(place.id);
                activePlace.value = placeData;
                showModal.value = true;
            }
            catch (error) {
                const isNotFound = error?.response?.data?.error === 'PLACE_NOT_FOUND' ||
                    error?.response?.status === 404;
                if (isNotFound) {
                    ctx.root.$toast.error(ctx.root.$t('api.place-not-found'));
                }
                else {
                    ctx.root.$toast.error(ctx.root.$t('api.general-error', { requestId: '' }));
                }
            }
        };
        return {
            placesCount,
            showModal,
            activePlace,
            isPopoverOpen,
            handlePlaceClick,
            contractedPlace,
        };
    },
});
